import { render, staticRenderFns } from "./MessageEditor.vue?vue&type=template&id=62afc6c6&scoped=true"
import script from "./MessageEditor.vue?vue&type=script&lang=js"
export * from "./MessageEditor.vue?vue&type=script&lang=js"
import style0 from "./MessageEditor.vue?vue&type=style&index=0&id=62afc6c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62afc6c6",
  null
  
)

export default component.exports